<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>{{ title }}</h2>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'home' }">Home</router-link>
          </li>
          <li class="active">
            <strong>{{ title }}</strong>
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>{{ title }}</h5>
            </div>
            <div class="ibox-content">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
    <remove-modal>
      <slot name="remove-button" />
    </remove-modal>
  </div>
</template>

<script>
import { RemoveModal } from '../modal'

export default {
  name: 'IndexTemplate',
  props: ['title'],
  components: {
    RemoveModal
  }
}
</script>
